import * as React from 'react';
import useLabelTranslation from 'src/hooks/useLabelTranslation';
import {useHistory} from 'src/rerouter/index';
import {useDispatch, useSelector} from 'react-redux';
import {getReferralSocialLinks} from 'src/action-creators/referrer-portal/dashboard';
import {selectSocialLinks} from 'src/selectors/referrer-portal';
import {
  PageTitle,
  TabSlot,
  TabList,
  Tab,
  RightSlot,
  Panel,
  Button,
  TitleMedium,
  Icon,
} from '@spaced-out/ui-design-system/lib/components/index';
import {duotoneIconStyle} from 'src/utils/app-shell';
import css from './tracking.css';


const MyReferrals = ({children}: {children: React.ReactNode}) => {
  const router = useHistory();
  const dispatch = useDispatch();

  const [isOpen, setIsOpen] = React.useState(false);
  const {t} = useLabelTranslation();

  const trackingTabs = [
    {
      tabId: '/referrals/leads',
      label: t('Referral_Request', 'Referral Request'),
    },
    {
      tabId: '/referrals/all-referrals',
      label: t('All_Referrals', 'All Referrals'),
    },
  ];

  const defaultSelectedTab = trackingTabs.find((settingsTab) =>
    router.location.pathname.includes(settingsTab.tabId),
  );

  const socialLinks = useSelector(selectSocialLinks);

  React.useEffect(() => {
    const handlePostMessage = (event: any) => {
      if (event?.data?.type === 'CLOSE_REFER_NOW_PANEL') {
        setIsOpen(event.data.showReferNowPanel);
      }
    };
    window.addEventListener('message', handlePostMessage);
    return () => {
      window.removeEventListener('message', handlePostMessage);
    };
  }, []);

  React.useEffect(() => {
    dispatch(getReferralSocialLinks());
  }, []);

  return (
    <>
      <PageTitle
        pageNameKey="referralTracking"
        classNames={{leftSlot: css.leftSlot}}
      >
        <TabSlot className={css.tabSlot}>
          <div className={css.header}>
            <TitleMedium>{t('Referrals', 'Referrals')}</TitleMedium>
            <Icon type="duotone" name="user-check" style={duotoneIconStyle} />
          </div>
          <TabList
            onSelect={(tab) => router.replace(tab.tabId)}
            size="medium"
            selectedTab={defaultSelectedTab}
          >
            {trackingTabs.map((tab) => (
              <Tab
                size="medium"
                key={tab.tabId}
                label={tab.label}
                tabId={tab.tabId}
              />
            ))}
          </TabList>
        </TabSlot>
        {socialLinks && (
          <RightSlot>
            <Button type="secondary" onClick={() => setIsOpen(true)}>
              {t('Refer', 'Refer')}
            </Button>
            <Panel
              isOpen={isOpen}
              tapOutsideToClose
              onClose={() => setIsOpen(false)}
              anchor="right"
              size="large"
              hideBackdrop={false}
            >
              <iframe
                src={`${socialLinks.long_url || ''}?iframe=true`}
                width="100%"
                height="100%"
                frameBorder="0"
              />
            </Panel>
          </RightSlot>
        )}
      </PageTitle>
      <div className={css.children}>{children}</div>
    </>
  );
};

export default MyReferrals;
